var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppointmentConfirm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 5.75C6.5 5.61193 6.61193 5.5 6.75 5.5H15.25C15.3881 5.5 15.5 5.61193 15.5 5.75V13.4865C15.5 13.9007 15.8358 14.2365 16.25 14.2365C16.6642 14.2365 17 13.9007 17 13.4865V5.75C17 4.7835 16.2165 4 15.25 4H6.75C5.7835 4 5 4.7835 5 5.75V17.25C5 18.2165 5.7835 19 6.75 19H9.92083C10.335 19 10.6708 18.6642 10.6708 18.25C10.6708 17.8358 10.335 17.5 9.92083 17.5H6.75C6.61193 17.5 6.5 17.3881 6.5 17.25V5.75ZM8.75 8C8.33579 8 8 8.33579 8 8.75C8 9.16421 8.33579 9.5 8.75 9.5H13.25C13.6642 9.5 14 9.16421 14 8.75C14 8.33579 13.6642 8 13.25 8H8.75ZM8 11.75C8 11.3358 8.33579 11 8.75 11H10.75C11.1642 11 11.5 11.3358 11.5 11.75C11.5 12.1642 11.1642 12.5 10.75 12.5H8.75C8.33579 12.5 8 12.1642 8 11.75ZM19.774 15.2866C20.0703 14.9972 20.076 14.5223 19.7866 14.226C19.4972 13.9296 19.0223 13.924 18.726 14.2134L14.7003 18.1447L13.2813 16.7206C12.9889 16.4272 12.514 16.4264 12.2206 16.7187C11.9272 17.0111 11.9264 17.486 12.2187 17.7794L14.1618 19.7294C14.4521 20.0207 14.9229 20.0239 15.2171 19.7366L19.774 15.2866Z",
    fill: "#C7CBE5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentConfirm);
export default __webpack_public_path__ + "static/media/appointment-confirm.2db01b7365df7e015a7ad1da7b0fcd04.svg";
export { ForwardRef as ReactComponent };